import React from "react";

export const ContactListContext = React.createContext({
  contacts: [],
  navigateNext: () => console.warn("Implement the navigation")
});
